import './style/ImageScale.css';
import { menu } from './Dispatching';
import { useDispatch } from 'react-redux';
import { saskelogo } from '../../images/images';


import React, { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger);

const MainLayout = () => {
    const textSectionRef = useRef(null);   // سكشن النصوص
	const readtex = Array("هل أنت مستعد".split(""))[0];
    var scentence = "";
    const dispatch = useDispatch();
    const firstSectionRef = useRef(null); // ريف السيكشن الأول
    const navbarRef = useRef(null);       // ريف الناف بار


    useGSAP(() => {
        // 1️⃣ إعداد الحالة المبدئية: الناف بار مخفي ومرفوع لفوق خارج الشاشة تماماً
        gsap.set(navbarRef.current, { y: -100, opacity: 0 });

        // 2️⃣ إنشاء مراقب ذكي يراقب السيكشن الأول
        ScrollTrigger.create({
            trigger: firstSectionRef.current,
            start: "top top", // 🎯 السحر هنا: الأنميشن يشتغل أول ما أسفل السيكشن الأول يلمس أعلى الشاشة (يعني بعد ما يخلص تماماً)
            
            onEnter: () => {
                // العميل نازل لتحت وعدى السيكشن الأول -> نزل الناف بار بـ أنميشن لطيف
                gsap.to(navbarRef.current, {
                    y: 0,
                    opacity: 1,
                    duration: 0.5,
                    ease: "power2.out"
                });
            },
            onLeaveBack: () => {
                // العميل طلع لفوق تاني ورجع للسيكشن الأول -> اخفي الناف بار واطلع بيه لفوق
                gsap.to(navbarRef.current, {
                    y: -100,
                    opacity: 0,
                    duration: 0.4,
                    ease: "power2.in"
                });
            }
        });



        const textTl = gsap.timeline({
            scrollTrigger: {
                trigger: textSectionRef.current,
                start: "top top",        // يبدأ أول ما سكشن النصوص يملس أعلى الشاشة
                end: "+=1500",           // يتجمد لمدة 1500 بكسل عشان النصوص تأخد وقتها في الإضاءة
                scrub: 1,
                pin: true,               // تجميد الشاشة
                pinSpacing: true,        // ⚠️ إجباري: يدفع سكشن الصورة للأسفل ويمنعه من الصعود حتى تنتهي النصوص تماماً
                onLeave:()=>{menu(dispatch);},
                onEnterBack:()=>{menu(dispatch);}
            }
        });
        
        // رحلة إضاءة النصوص داخل التايم لاين
        textTl.to(".read-tex", {
            opacity: 1,
            color: "#fff",
            stagger: { each: 0.2, from: 'end' }
        })
        .to(".read-tex1", {
            opacity: 1,
            scale: 2,
            y: "40%",
            x: "20%",
            color: "#fff"
        }, "+=0.2")
    });
        readtex.forEach(e => {
        if(e==="ل"){
            scentence = scentence.concat(e)
        }
        else if(e==="أ"){
            scentence = scentence.concat(e)
        }
        else if(e==="ت"){
            scentence = scentence.concat(e)
            
        }
        else{
            scentence = scentence.concat(e)
        }
    });
    return (
        <div style={{ background: '#0b0c10', color: '#fff', minHeight: '100vh'}}>
            
            {/* 🖥️ الـ Navbar (مخفي في الموبايل ويظهر كمبيوتر فقط بدقة) */}
            <nav 
                ref={navbarRef} 
                className="desktop-navbar"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '70px',
                    backgroundColor: 'rgba(11, 12, 16, 0.85)',
                    backdropFilter: 'blur(10px)', // تأثير زجاجي فخم
                    borderBottom: '1px solid rgba(99, 102, 241, 0.2)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '0 50px',
                    zIndex:100000
                }}
            >
                <div style={{ fontWeight: 'bold', fontSize: '1.5rem', color: '#6366f1' }}><img alt='saske logo' src={saskelogo} width={100} /></div>
                <ul style={{ display: 'flex', gap: '30px', listStyle: 'none', margin: 0, padding: 0, direction:'rtl' }}>
                    <li><a href="/" style={{ color: '#fff', textDecoration: 'none' }}> الرئيسية🏠</a></li>
                    <li><a href="#services" style={{ color: '#fff', textDecoration: 'none' }}> خدماتنا البرمجية💼</a></li>
                    <li><a href="#revs" style={{ color: '#fff', textDecoration: 'none' }}> تقييمات SASKE🚀</a></li>
                    <li><a href="#contact" style={{ color: '#6366f1', textDecoration: 'none', border: '1px solid #6366f1', padding: '5px 15px', borderRadius: '5px' }}> تواصل معنا📞</a></li>
                </ul>
            </nav>

            <div ref={textSectionRef} className="scale-section-container">
                <div className="spacer-before">
                    <div>
                        <h1>
                            {scentence.split("").reverse().map((e, i)=> <div className="read-tex" style={{whiteSpace: e === " " ? "pre" : "normal"}}>{e==="ل" || e==="أ" || e==="ت" & i === 6 || e===" " || e==="د" ? e : e+"ـ"}</div>)}
                        </h1>
                        <h1 className="read-tex1"> ...فلنبدأ الأن</h1>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainLayout;